var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.emoji)?_c('span',{staticClass:"group-user-status"},[_vm._v(_vm._s(_vm.emoji))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }